import { useAuth } from "@qure/qure-auth";

/** Returns whether the current user's workspace has SMS features enabled. */
export function useSmsEnabled() {
  var _settings;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  return Boolean(userInfo === null || userInfo === void 0 || (_settings = userInfo.settings) === null || _settings === void 0 || (_settings = _settings.ui_settings) === null || _settings === void 0 ? void 0 : _settings.sms);
}